import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSentimentNeutral = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8648 15.4603H9.50088M21.6829 12.2783C21.6829 17.2489 17.6534 21.2783 12.6829 21.2783C7.7123 21.2783 3.68286 17.2489 3.68286 12.2783C3.68286 7.30776 7.7123 3.27832 12.6829 3.27832C17.6534 3.27832 21.6829 7.30776 21.6829 12.2783ZM10.4329 10.0283C10.4329 10.4425 10.265 10.7783 10.0579 10.7783C9.85075 10.7783 9.68286 10.4425 9.68286 10.0283C9.68286 9.61411 9.85075 9.27832 10.0579 9.27832C10.265 9.27832 10.4329 9.61411 10.4329 10.0283ZM10.0579 10.0283H10.0654V10.0433H10.0579V10.0283ZM15.6829 10.0283C15.6829 10.4425 15.515 10.7783 15.3079 10.7783C15.1008 10.7783 14.9329 10.4425 14.9329 10.0283C14.9329 9.61411 15.1008 9.27832 15.3079 9.27832C15.515 9.27832 15.6829 9.61411 15.6829 10.0283ZM15.3079 10.0283H15.3154V10.0433H15.3079V10.0283Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSentimentNeutral;
